import Locale from '../../../vmc-calendar/locale/zh_CN';

export default Locale;
